import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=78589ef2&scoped=true"
import script from "./AppSideBar.vue?vue&type=script&lang=js"
export * from "./AppSideBar.vue?vue&type=script&lang=js"
import style0 from "./AppSideBar.vue?vue&type=style&index=0&id=78589ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78589ef2",
  null
  
)

export default component.exports